import React, { FunctionComponent } from 'react';
import { FunctionField } from 'react-admin';
import { formatEuro } from '../../helpers/formatCurrency';

interface EuroFieldProps {
  source: string;
  label?: string;
}

const EuroField: FunctionComponent<EuroFieldProps> = ({ source, label }) => (
  <FunctionField
    source={source}
    label={label}
    render={(record: any) => {
      if (!record || record[source] == null) return null;

      return (
        <span style={{ whiteSpace: 'nowrap' }}>
          {formatEuro(record[source])}
        </span>
      );
    }}
  />
);

export default EuroField;
